import styled from "styled-components";
import Img from "gatsby-image";
import BackgroundImage from "gatsby-background-image";

export const ProjectBackgroundImageContainer = styled.div`
  position: relative;
  justify-content: center;
  align-items: center;
  padding: relative;
`;
export const ProjectBannerBg = styled.div`
  overflow: hidden;
  /* display: block; */
  /* align-items: center; */
  min-height: 400px;
  /* min-width: 1000px; */
  padding-top: 4rem;
  filter: brightness(50%);
  @media screen and (max-width: 600px) {
    display: block;
  }
  @media screen and (max-width: 368px) {
    display: block;
  }
`;
// export const ProjectBannerImage = styled(Img)`
//   /* border-radius: 10px; */
//   height: 100%;
//   filter: brightness(80%);
// `;
export const ProjectBannerImage = styled(BackgroundImage)`
  /* border-radius: 10px; */
  height: 100%;
  filter: brightness(50%);
  margin: 0px;
  transition: 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);

  background-attachment: scroll;
`;
